import { STATUS_LABELS } from "@/lib/money";

export const inputCls =
  "w-full rounded-xl border border-[#2E2A24] bg-[#0A0A0C] px-3.5 py-2.5 text-sm text-[#F5EFE6] outline-none transition-[border-color] focus:border-[#C4832B]";

export const Field = ({ label, children, className = "" }) => (
  <label className={`block ${className}`}>
    <span className="mb-1.5 block font-mono-rc text-[11px] uppercase tracking-[0.18em] text-zinc-400">{label}</span>
    {children}
  </label>
);

export const Btn = ({ variant = "ghost", className = "", ...props }) => {
  const styles = {
    primary: "bg-[#C4832B] text-[#0A0A0C] hover:bg-[#E09838]",
    ghost: "border border-[#2E2A24] text-[#F5EFE6] hover:border-[#C4832B]",
    danger: "text-red-400 hover:text-red-300",
  };
  return <button type="button" className={`inline-flex items-center justify-center gap-2 rounded-full px-4 py-2 text-sm transition-[background-color,border-color] disabled:opacity-50 ${styles[variant]} ${className}`} {...props} />;
};

export const StatusPill = ({ status }) => (
  <span className={`inline-block rounded-full px-3 py-1 text-xs ${["signed", "paid"].includes(status) ? "bg-emerald-500/15 text-emerald-300" : status === "draft" ? "border border-[#2E2A24] text-zinc-300" : status === "void" ? "text-zinc-500 line-through" : "bg-[#C4832B]/20 text-[#E09838]"}`}>
    {STATUS_LABELS[status] ?? status}
  </span>
);

export const Empty = ({ children, testId }) => (
  <p className="rounded-2xl border border-dashed border-[#2E2A24] p-10 text-center text-zinc-400" data-testid={testId}>{children}</p>
);

export const dialogCls = "max-h-[90vh] max-w-3xl overflow-y-auto border-[#2E2A24] bg-[#121215] text-[#F5EFE6]";
